import http, { url } from '../../http'

const API_URL = "work-plan"

class WorkPlanAPI {

  async getAll(companyId, page = 1, year = null) {
    let path = `${API_URL}/company/${companyId}?page=${page}`
    if (year) path += `&year=${year}`
    const response = await http(path, 'GET')
    return response || null
  }

  async get(id) {
    const response = await http(`${API_URL}/${id}`, 'GET')
    return response || null
  }

  async save(data) {
    const response = await http(`${API_URL}/save`, 'POST', data)
    return response
  }

  async update(id, data) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', data)
    return response
  }

  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }

  // Plan de Trabajo Anual branded: la app genera el PDF y el encargado firma.
  pdfUrl(id) {
    return url(`${API_URL}/${id}/pdf`)
  }

  async sign(id, payload) {
    return await http(`${API_URL}/${id}/sign`, 'POST', payload)
  }

  async status(id) {
    return await http(`${API_URL}/${id}/status`, 'GET')
  }
}

export default new WorkPlanAPI()
